import {IBox, IFruits} from "src/store/models";

export const sortFruitsReducer = (oldState: IFruits, boxesWithUpdatedIds: IBox[]) => {
    const nextState = {...oldState};
    boxesWithUpdatedIds.map((box: any) => {
        box.fruitsIds.map((fruitId: string) => {
            nextState[fruitId] = {
                ...nextState[fruitId],
                box: box.selfId
            }
        })
    });
    return nextState
};


// WEBPACK FOOTER //
// ./src/store/reducers/sorting/sortFruitsReducer.ts